[
  {
    "id": "behavioral-intelligence",
    "title": "BEHAVIORAL INTELLIGENCE: BUILDING TRUST & CHARGING FORWARD",
    "category": "Whitepaper",
    "date": "2026-01-20",
    "excerpt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "image": "/assets/redesign/popup-image.jpg",
    "featured": true,
    "buttonText": "Get whitepaper"
  },
  {
    "id": "featured-article-2",
    "title": "INSERT NAME OF ARTICLE OR REPORT HERE",
    "category": "Whitepaper",
    "date": "2026-01-20",
    "excerpt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "image": "/assets/redesign/popup-image.jpg",
    "featured": true,
    "buttonText": "Get whitepaper"
  },
  {
    "id": "news-article-1",
    "title": "INSERT NAME OF ARTICLE OR REPORT HERE",
    "category": "News",
    "date": "2026-01-20",
    "excerpt": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    "image": "/assets/contact_us_cta.jpg",
    "featured": false,
    "buttonText": ""
  }
]